import { useIntl } from "react-intl";

const InspectPermissions = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.inspectPermissions.header",
            defaultMessage: "Inspect permissions"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.features.inspectPermissions.content",
            defaultMessage:
                "Understand all active permissions for a specific user in one place so you can address issues quickly."
        }),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.features.inspectPermissions.altText",
            defaultMessage: "Example of inspect permissions"
        }),
        caption: intl.formatMessage({
            id: "ConfluencePricingPage.features.inspectPermissions.caption",
            defaultMessage:
                "Here’s an example of inspect permissions in Confluence."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/Inspect_Perms-optimized.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
            <p>{messages.caption}</p>
        </>
    );
};

export default InspectPermissions;
